"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = void 0;
const development = {
    heapAppId: '2974304304',
    campari: 'http://localhost:8080',
    yoink: 'http://localhost:8081',
    jagermeister: 'http://localhost:3000',
    caipirinha: 'http://localhost:9000',
    kvStore: 'http://localhost:5055',
};
const production = {
    heapAppId: '413792583',
    campari: 'https://streamelements.com',
    yoink: 'https://yoink.streamelements.com',
    jagermeister: 'https://streamelements.com/dashboard',
    caipirinha: 'https://api.streamelements.com',
    kvStore: 'https://kvstore.streamelements.com',
};
const staging = {
    heapAppId: '2974304304',
    campari: 'https://staging.streamelements.com',
    yoink: 'https://yoink.staging.streamelements.com',
    jagermeister: 'https://staging.streamelements.com/dashboard',
    caipirinha: 'https://api.staging.streamelements.com',
    kvStore: 'https://kvstore.staging.streamelements.com',
};
exports.config = {
    heapAppId: {
        production: production.heapAppId,
        staging: staging.heapAppId,
        development: development.heapAppId,
    },
    campari: {
        production: production.campari,
        staging: staging.campari,
        development: development.campari,
    },
    yoink: {
        production: production.yoink,
        staging: staging.yoink,
        development: development.yoink,
    },
    jagermeister: {
        production: production.jagermeister,
        staging: staging.jagermeister,
        development: development.jagermeister,
    },
    caipirinha: {
        production: production.caipirinha,
        staging: staging.caipirinha,
        development: development.caipirinha,
    },
    kvStore: {
        production: production.kvStore,
        staging: staging.kvStore,
        development: development.kvStore,
    },
};
